import {$m, $s} from '@/app'

/**
 * Panel collapse state: only below the desktop breakpoint.
 * Wide viewports: always `false` so the cart column and totals stay expanded.
 * SSR: `false` (no `window`).
 */
export function panel_cart_collapsed(): boolean {
    if (typeof globalThis === 'undefined' || typeof window === 'undefined') {
        return false
    }
    /** Matches theme `$breakpoint-40` (3-column shop grid). */
    if (window.matchMedia(`(min-width: 1550px)`).matches) {
        return false
    }
    return $s.panels.context.collapsed
}

/** Units shown in the peek label (cart lines take priority over booked-only totals). */
export function panel_cart_peek_units(): number {
    const u = $m.cart.cart_units()
    if (u > 0) {
        return u
    }
    return $s.cart.show_bottles ? $m.cart.booked_bottles() : $m.cart.booked_cases()
}
